import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { cxTw, Tooltip, TooltipPlacement } from '@asigna/kit';
import classNames from 'classnames';

import classes from './index.module.scss';
// TODO before moving to ui kit improve component structure and className passing

type Props = {
  checked?: boolean;
  children?: string;
  disabled?: boolean;
  disabledHint?: string | null;
  hintPosition?: TooltipPlacement;
  onCheck: Dispatch<SetStateAction<boolean>>;
  className?: string;
};

export const Switch = ({
  checked,
  children,
  onCheck,
  disabled,
  disabledHint,
  hintPosition,
  className,
}: PropsWithChildren<Props>) => {
  const SwitchInput = (
    <label
      className={cxTw(
        'flex items-center gap-x-[12px] text-r13 cursor-pointer',
        checked ? 'text-regular-fa' : 'text-regular',
        disabled && 'opacity-40 text-regular-fa cursor-not-allowed',
        className
      )}
    >
      <div className={cxTw(classes.toggleWrapper, checked ? classes.toggleWrapperChecked : '')}>
        <input
          checked={checked}
          disabled={disabled}
          type="checkbox"
          className="hidden"
          onClick={() => !disabled && onCheck((prevState) => !prevState)}
          onChange={() => <></>}
        />
        <span className={classNames(classes.toggle, checked ? classes.toggleChecked : '')} />
      </div>
      {children && <span>{children}</span>}
    </label>
  );

  if (disabled && disabledHint) {
    return (
      <Tooltip content={disabledHint} position={hintPosition}>
        {SwitchInput}
      </Tooltip>
    );
  }

  return SwitchInput;
};
